/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiSuccess } from '../../models/api-success';

export interface DeleteFboLocationGroups$Params {

/**
 * List of database identifiers to delete.
 */
  ids: Array<number>;
}

export function deleteFboLocationGroups(http: HttpClient, rootUrl: string, params: DeleteFboLocationGroups$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiSuccess>> {
  const rb = new RequestBuilder(rootUrl, deleteFboLocationGroups.PATH, 'delete');
  if (params) {
    rb.query('ids', params.ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiSuccess>;
    })
  );
}

deleteFboLocationGroups.PATH = '/api/administration/fbo-locations-groups';
